/* global http submitReservation */
const validateVoucher = {
	el: {
		body: document.body,
		btnSubmitVoucher: document.querySelector('.js-submit-voucher-code'),
		inputVoucherCode: document.querySelector('.js-voucher-code'),
		inputAmount: document.querySelector('.js-amount'),
		containerSummary: document.querySelector('.content__summary'),
		btnRemoveVoucher: document.querySelector('.js-remove-discount'),
		discountField: document.querySelector('.content__summary-discount'),
		subtotalField: document.querySelector('.content__summary-subtotal'),
		containerFinalPrice: document.querySelector('.js-reservation-final-price'),
		voucherErrorMessage: document.querySelector('.js-voucher-code-error-message'),
		subTotalPrice: document.querySelector('.js-reservation-subtotal')
	},

	fxValidateVoucher(el) {

		// get endpoint
		const endpoint = el.getAttribute('data-action')

		// get language that has to be sent to api
		const languageParameter = this.el.body.dataset.language

		// set formData
		const BookingLines = submitReservation.vars.bookingLines

		//-hide and reset error message
		this.el.voucherErrorMessage.style.display = 'none'
		this.el.voucherErrorMessage.innerHTML = ''

		const formData = {
			BookingLines,
			'VoucherCode': el.previousElementSibling.value,
			'HotelCode': document.querySelector('.js-hotel-code').value,
			'NumberOfGuests': document.querySelector('.js-hosts').value
		}

		// callback function 
		const callback = (response, data) => response.status === 200 && this.fxUpdateData(el, data)

		// call api
		http.fxPost(endpoint, formData, callback, languageParameter)
	},

	fxUpdateData(el, data) {
		const discountName = this.el.containerSummary.querySelector('.js-discount-voucher-name'),
			button = document.querySelector('[data-section-next="3"]'),
			buttonCopy = button.firstElementChild

		if (data.isVoucherApplied) {
			// update inputs
			this.el.inputVoucherCode.value = el.previousElementSibling.value
			this.el.inputAmount.value = data.totalAmountAfterTax

			//- update styles and sidepanel
			this.el.discountField.style.display = 'flex'
			this.el.subtotalField.style.display = 'block'
			discountName.innerHTML = data.voucherDescription
			this.el.containerFinalPrice.innerHTML = data.totalAmountAfterTax
			this.el.voucherErrorMessage.style.display = 'none'

			button.firstElementChild.textContent = data.totalAmountAfterTax === '0,00' ?  buttonCopy.dataset.copyConfirm : buttonCopy.dataset.copyPayment
		}
		else {
			let message

			switch (data.errorCode) {
				case 1:
					message = el.dataset.voucherNotApplied
					break
				case 2:
					message = el.dataset.voucherInvalid
					break
				case 3:
					message = el.dataset.voucherSoldOut
					break
				case 4:
					message = el.dataset.voucherExpired
					break
				case 5:
					message = el.dataset.voucherInactive
					break
				case 6:
					message = el.dataset.voucherInvalidHostel
					break
				case 7:
					message = el.dataset.voucherInvalidTypology
					break
			}

			this.el.voucherErrorMessage.style.display = 'flex'
			this.el.voucherErrorMessage.innerHTML = message
		}
	},

	fxRemoveVoucher() {
		this.el.discountField.style.display = 'none'
		this.el.subtotalField.style.display = 'none'
		this.el.inputVoucherCode.value = ''
		this.el.btnSubmitVoucher.previousElementSibling.value = ''
		this.el.containerFinalPrice.textContent = this.el.subTotalPrice.textContent
		this.el.inputAmount.value = this.el.subTotalPrice.textContent
	},

	events() {
		// check if element exists
		if (!this.el.btnSubmitVoucher) return

		this.el.btnSubmitVoucher.addEventListener('click', e => this.fxValidateVoucher(e.currentTarget))
		this.el.btnRemoveVoucher.addEventListener('click', () => this.fxRemoveVoucher())
	},

	init() {
		this.events()
	}
}

validateVoucher.init()